import { useEffect, useState } from "react";
import api from "@/lib/api";
import GenericCrudPage from "./GenericCrudPage";

const TYPES = ["excavator", "roller", "paver", "grader", "crane", "truck", "other"].map((v) => ({
  value: v, label: v.charAt(0).toUpperCase() + v.slice(1),
}));

const STATUS = [
  { value: "active", label: "Active" },
  { value: "maintenance", label: "Maintenance" },
  { value: "idle", label: "Idle" },
  { value: "sold", label: "Sold" },
];

export default function MachineryPage() {
  const [projects, setProjects] = useState([]);
  useEffect(() => { api.get("/projects").then((r) => setProjects(r.data)); }, []);

  return (
    <GenericCrudPage
      testid="machinery"
      overline="EQUIPMENT"
      title="Machinery"
      description="Excavators, rollers, pavers, cranes and other heavy machinery inventory."
      endpoint="/machinery"
      defaults={{ name: "", machine_type: "excavator", registration_number: "", purchase_date: "", status: "active", assigned_project_id: "", notes: "" }}
      fields={[
        { name: "name", label: "Machine Name/ID", type: "text" },
        { name: "machine_type", label: "Type", type: "select", options: TYPES },
        { name: "registration_number", label: "Registration No.", type: "text" },
        { name: "status", label: "Status", type: "select", options: STATUS },
        { name: "purchase_date", label: "Purchase Date", type: "date" },
        { name: "assigned_project_id", label: "Assigned Project", type: "select", options: projects.map((p) => ({ value: p.id, label: p.name })) },
        { name: "notes", label: "Notes", type: "textarea", colSpan: 2 },
      ]}
      columns={["name", "machine_type", "registration_number", "status"]}
    />
  );
}
